import { render, staticRenderFns } from "./RubberMaterial.vue?vue&type=template&id=211460fc&scoped=true&"
import script from "./RubberMaterial.vue?vue&type=script&lang=js&"
export * from "./RubberMaterial.vue?vue&type=script&lang=js&"
import style0 from "./RubberMaterial.vue?vue&type=style&index=0&id=211460fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211460fc",
  null
  
)

export default component.exports